import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
export function TabPanel(props) {
    const { children, value, index, id } = props;
    return (_jsx(Box, { role: "tabpanel", hidden: value !== index, id: `${id}-tabpanel-${index}`, "aria-labelledby": `${id}-tab-${index}`, sx: { height: '100%', overflow: 'auto', p: 2 }, children: value === index && children }));
}
//# sourceMappingURL=TabPanel.js.map